import { OrderedMap } from 'immutable';
import * as ActionTypes from '../../actions/ActionTypes';
import CategoryOrganizationRecord from '../../records/edit/CategoryOrganizationRecord';
import CategoryRecord from '../../records/edit/CategoryRecord';
import CategoryTranslationRecord from '../../records/CategoryTranslationRecord';
export function getOrderedMapCategories({
  categories = []
}) {
  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  return new OrderedMap(categories.map(category => [category.id, CategoryRecord.from(category)]));
}
function addPrimaryLanguageDefaults(payload) {
  const {
    categories = [],
    primaryLanguage
  } = payload;
  categories.forEach(category => {
    const {
      translations
    } = category;
    const subcategories = category.subcategories || [];
    subcategories.forEach(subcategory => {
      const {
        translations: subcategoryTranslations
      } = subcategory;
      const primaryTranslation = subcategoryTranslations && subcategoryTranslations.find(t => t.language === primaryLanguage);
      if (primaryTranslation) {
        subcategory.name = primaryTranslation.name;
      }
    });
    const primaryTranslation = translations && translations.find(t => t.language === primaryLanguage);
    if (primaryTranslation) {
      category.name = primaryTranslation.name;
      category.description = primaryTranslation.description;
    }
  });
  return payload;
}
function updateAllArticles(state, articleUpdater) {
  return state.withMutations(mutState => mutState.update('categories', categories => categories.map(category => category.update('articles', articles => articles.map(articleUpdater)).update('subcategories', subcategories => subcategories.map(subcategory => subcategory.update('articles', articles => articles.map(articleUpdater)))))));
}
const updateCategoryFromTranslationSuccess = (state, response) => {
  const {
    categories
  } = response;
  const category = CategoryTranslationRecord.fromJS(categories[0]);
  const indexToUpdate = category.knowledgeCategoryId;
  return state.mergeIn(['categories', indexToUpdate], {
    translations: category.nameTranslations
  });
};
const INITIAL_STATE = new CategoryOrganizationRecord();
export default function categoryOrganizationInfo(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.CLEAR_ORGANIZE_STATE:
      return INITIAL_STATE;
    case ActionTypes.FETCH_CATEGORIES_ORGANIZATION_PENDING:
    case ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_PENDING:
      return state.set('isRequesting', true);
    case ActionTypes.FETCH_TRANSLATED_CATEGORY_SUCCESS:
      {
        const {
          hydratedCategory,
          totalPublishedArticles,
          selectedCategoryId,
          translatedParentCategories
        } = action.payload;
        const selectedCategoryIndex = translatedParentCategories.categories.findIndex(category => category.id === selectedCategoryId);
        const categoryLike = Object.assign({}, hydratedCategory.categories[0], {
          totalPublishedArticles
        });
        translatedParentCategories.hydrated.push(selectedCategoryId);
        translatedParentCategories.categories[selectedCategoryIndex] = categoryLike;
        return state.set('translatedParentCategories', translatedParentCategories);
      }
    case ActionTypes.FETCH_TRANSLATED_CATEGORIES_SUCCESS:
      return state.set('translatedParentCategories', action.payload);
    case ActionTypes.FETCH_SUBCATEGORIES_FOR_PARENT_SUCCESS:
      return state.merge({
        categories: action.payload.categories,
        isRequesting: false,
        lastLoaded: new Date().valueOf()
      });
    case ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_SUCCESS:
      return state.merge({
        categories: getOrderedMapCategories(addPrimaryLanguageDefaults(action.payload)),
        isRequesting: false,
        lastLoaded: new Date().valueOf(),
        requestedLanguage: action.payload.requestedLanguage,
        primaryLanguage: action.payload.primaryLanguage
      });
    case ActionTypes.FETCH_CATEGORIES_ORGANIZATION_SUCCESS:
      return state.merge({
        categories: getOrderedMapCategories(action.payload),
        isRequesting: false,
        lastLoaded: new Date().valueOf(),
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'undefined'.
        requestedLanguage: null,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'undefined'.
        primaryLanguage: null
      });
    case ActionTypes.FETCH_CATEGORIES_ORGANIZATION_ERROR:
    case ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_ERROR:
      return state.merge({
        error: action.error,
        isRequesting: false
      });
    case ActionTypes.CREATE_CATEGORY_PENDING:
      return state.merge({
        error: undefined,
        isCreating: true
      });
    case ActionTypes.CREATE_CATEGORY_SUCCESS:
      return state.merge({
        error: undefined,
        isCreating: false,
        lastCreated: new Date().valueOf()
      });
    case ActionTypes.CREATE_CATEGORY_ERROR:
      return state.merge({
        error: action.error,
        isCreating: false
      });
    case ActionTypes.UPDATE_CATEGORY_PENDING:
      return state.merge({
        isUpdating: true,
        error: undefined
      });
    case ActionTypes.UPDATE_CATEGORY_SUCCESS:
      return state.merge({
        error: undefined,
        isUpdating: false,
        lastUpdated: new Date().valueOf()
      });
    case ActionTypes.UPDATE_CATEGORY_ERROR:
      return state.merge({
        isUpdating: false,
        error: action.error
      });
    case ActionTypes.UPDATE_CATEGORY_TRANSLATIONS_SUCCESS:
      return updateCategoryFromTranslationSuccess(state, action.payload);
    case ActionTypes.UPDATE_CATEGORY_ORDERING_PENDING:
    case ActionTypes.UPDATE_SUBCATEGORY_ORDERING_PENDING:
    case ActionTypes.UPDATE_ARTICLE_ORDERING_PENDING:
      return state.merge({
        isOrdering: true
      });
    case ActionTypes.UPDATE_CATEGORY_ORDERING_SUCCESS:
    case ActionTypes.UPDATE_SUBCATEGORY_ORDERING_SUCCESS:
    case ActionTypes.UPDATE_ARTICLE_ORDERING_SUCCESS:
      return state.merge({
        isOrdering: false,
        lastLoaded: new Date().valueOf(),
        orderingSuccess: true
      });
    case ActionTypes.UPDATE_CATEGORY_ORDERING_ERROR:
    case ActionTypes.UPDATE_SUBCATEGORY_ORDERING_ERROR:
    case ActionTypes.UPDATE_ARTICLE_ORDERING_ERROR:
      return state.merge({
        isOrdering: false,
        orderingSuccess: false
      });
    case ActionTypes.APPLY_TAG_TO_ARTICLES_SUCCESS:
      {
        const response = action.payload;
        const tagId = response.id;
        const {
          articleIds
        } = action;
        return updateAllArticles(state, article => {
          if (articleIds.includes(article.values.hs_id) && !article.values.hs_tag_ids.includes(tagId)) {
            return article.setIn(['values', 'hs_tag_ids'], article.values.hs_tag_ids.concat(tagId));
          } else if (article.values.hs_tag_ids.includes(tagId) && !articleIds.includes(article.values.hs_id)) {
            const clone = [...article.values.hs_tag_ids];
            return article.setIn(['values', 'hs_tag_ids'], clone.splice(clone.indexOf(tagId), 1));
          }
          return article;
        });
      }
    default:
      return state;
  }
}